
import React, { useState } from 'react'
import { AchievementReward } from '../../data/rewards'
import { t } from '../../data/translations'

interface RewardNodeProps {
    reward: AchievementReward
    status: 'locked' | 'unlocked' | 'claimed'
    onClaim: (level: number) => void
    isLast?: boolean
}

export const RewardNode: React.FC<RewardNodeProps> = ({ reward, status, onClaim, isLast }) => {
    const [isHovered, setIsHovered] = useState(false)

    const isMajor = reward.isMajor
    const nodeSize = isMajor ? 'w-16 h-16' : 'w-12 h-12'
    const imageSize = isMajor ? 'w-12 h-12' : 'w-8 h-8'

    // Styles based on status
    const borderStyle = status === 'locked'
        ? 'border-gray-600 bg-gray-900'
        : status === 'claimed'
            ? 'border-[#DAA520] bg-[#3E2723]'
            : 'border-[#00FFFF] bg-[#000033] shadow-[0_0_15px_#00FFFF]'

    const grayscale = status === 'locked' ? 'grayscale opacity-50' : ''
    const animatePulse = status === 'unlocked' ? 'animate-pulse' : ''

    return (
        <div className="relative flex flex-col items-center group z-10"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Node Circle */}
            <div
                className={`
          ${nodeSize} rounded-full border-[3px] flex items-center justify-center 
          transition-all duration-300 transform hover:scale-110 cursor-pointer
          ${borderStyle} ${animatePulse} relative
        `}
                onClick={() => status === 'unlocked' && onClaim(reward.level)}
            >
                {/* Glow effect for unlocked */}
                {status === 'unlocked' && (
                    <div className="absolute inset-0 rounded-full bg-cyan-400 opacity-20 animate-ping"></div>
                )}

                <img
                    src={reward.emoteId ? `/assets/emotes/${reward.emoteId.toLowerCase()}.png` : reward.assetUrl}
                    className={`${imageSize} object-contain ${grayscale} transition-all duration-300 z-20`}
                    alt={reward.title}
                />

                {/* Claimed Checkmark overlay */}
                {status === 'claimed' && (
                    <div className="absolute inset-0 flex items-center justify-center z-30 bg-black/40 rounded-full">
                        <span className="text-green-400 text-xl font-bold">✓</span>
                    </div>
                )}

                {/* Level Badge */}
                <div className="absolute -bottom-2 bg-black/80 border border-[#DAA520] px-1.5 rounded text-[10px] font-bold text-[#DAA520]">
                    Lvl {reward.level}
                </div>
            </div>

            {/* Connection Line Spacer removed - Parent uses justify-between */}

            {/* Tooltip disabled as per user request */}
        </div>
    )
}
